import type { SVGProps } from 'react';
import ZepIcon from '../ZepIcon';
export const ExclamationmarkSmallIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
      <path fill={props.fill || `currentColor`} d="M12 14a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1M10.5 16.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" />
    </svg>);